<template>
    <router-view class="root"/>
</template>

<script>
    export default {
        name: 'app',
        components: {}
    }
</script>

<style>
    * {
        padding: 0;
        margin: 0;
    }

    body, html, .root {
        height: 100%;
        width: 100%;
        /*这个属性会影响后退返回原坐标*/
        /*overflow-x: hidden;*/
    }

    body {
        overflow-x: hidden;
    }

    .expand .el-table__expand-column .cell {
        display: none;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }

    /*小于60分的行背景*/
    .el-table .lg60 {
      background: #e4eedc;
    }
</style>
